module.exports = __webpack_public_path__ + "img/w_stu_header.f8d76254.png";